export default {
  form: {
    address: {
      label: 'Adresse',
      placeholder: 'Gade + nummer',
    },
    city: {
      label: 'By',
      placeholder: 'By',
    },
    state: {
      label: 'Region',
      placeholder: 'Vælg region',
    },
    country: {
      label: 'Land',
      placeholder: 'Vælg land',
    },
    zip_code: {
      label: 'Postnummer',
      placeholder: 'Postnummer',
    },
  },
};
